import { ROUTES } from 'src/enums';

export default [
  {
    path: '/profile',
    meta: { auth: true, profile: true },
    component: () => import('layouts/SpaLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('layouts/ProfileLayout.vue'),
        children: [
          {
            path: '',
            name: ROUTES.PROFILE.INDEX,
            component: () => import('pages/ProfilePage.vue'),
          },
          {
            path: 'security',
            name: ROUTES.PROFILE.SECURITY,
            component: () => import('pages/ProfileSecurityPage.vue'),
          },
          {
            path: 'smtp',
            name: ROUTES.PROFILE.SMTP,
            component: () => import('pages/SmtpPage.vue'),
          },
          {
            path: 'email-chains',
            name: ROUTES.PROFILE.EMAIL_CHAINS,
            component: () => import('pages/EmailChainsPage.vue'),
          },
          {
            path: 'autoresponder',
            name: ROUTES.PROFILE.AUTORESPONDER,
            component: () => import('pages/AutoresponderPage.vue'),
          },
          {
            path: 'domains',
            name: ROUTES.PROFILE.DOMAINS,
            component: () => import('pages/DomainsPage.vue'),
          },
          {
            path: 'brand-voice',
            name: ROUTES.PROFILE.BRAND_VOICE,
            component: () => import('pages/BrandVoicePage.vue'),
          },
          {
            path: 'team-members',
            name: ROUTES.PROFILE.TEAM_MEMBERS,
            component: () => import('pages/TeamMembersPage.vue'),
          },
          {
            path: 'payment-providers',
            name: ROUTES.PROFILE.PAYMENT_PROVIDERS,
            component: () => import('pages/PaymentProviders.vue'),
          },
        ],
      },
      {
        name: ROUTES.PROFILE.CONFIRM_EMAIL,
        path: 'email/confirm/:guid',
        props: true,
        component: () => import('pages/ConfirmEmailPage.vue'),
      },
      {
        name: ROUTES.PROFILE.CONFIRM_DELETE_ACCOUNT,
        path: 'delete/confirm/:confirmGuid',
        props: true,
        component: () => import('pages/ConfirmDeleteAccountPage.vue'),
      },
    ],
  },
];
